import React from 'react'
// import React, { useState } from 'react'
import "./payment.css"
import CheckoutProduct from "./CheckoutProduct";
import { useStateValue } from '../StateProvider';
import CurrencyFormat from 'react-currency-format';
import { getCartTotal } from '../reduce';

// import { useStripe, useElements,CardElement  } from '@stripe/react-stripe-js';
// import { PaymentElement } from '@stripe/react-stripe-js';


function Payment({ user }) {

  const [{ cart }] = useStateValue();

  // const stripe = useStripe();
  // const elements = useElements();


  // const handleSubmit = async (event) => {
  //   event.preventDefault();
  //   if (!stripe || !elements) {
  //     return;
  //   }

  //   const result = await stripe.confirmPayment({
  //     elements,
  //     confirmParams: {
  //       return_url: "https://example.com/order/123/complete",
  //     },
  //   });

  //   if (result.error) {
  //     console.log(result.error.message);
  //   } else {
  //   }
  // };

  // const handleChange = (event) => {
  //   SetDisabled(event.empty)
  //   SetError(event.error ? event.error.message : "")
  // }

  return (
    <div className='payment'>

      <div className='payment_container'>
        <div className='payment_address'>
          <div className="payment_title">
            <h1>Delivery Address</h1>
          </div>
          <div className="payment_addressInfo">
            <p>{user?.email}</p>
            <p>Room no: 123, Building: XYZ</p>
            <p>Kharghar:410210</p>
            <p>Navi Mumbai,India.</p>
          </div>
        </div>
        <div className='payment_main'>
          <div className='payment_item'>

            <h1>Checkout (
              {cart.length || "0"} Items
              )
            </h1>

            {cart.map((item) => {
              const { id, product_name, product_price, imagepic, product_rating } = item;
              return (
                <>
                  <CheckoutProduct
                    id={id}
                    product_name={product_name}
                    product_price={product_price}
                    imagepic={imagepic}
                    product_rating={product_rating}
                  />
                </>
              )
            })}

          </div>

          <div className='payment_method'>

            <form >
              {/* <CardElement onChange={handleChange} />  */}
              {/*<PaymentElement /> */}

              <div className='payment_methodContainer'>
                <CurrencyFormat
                  renderText={(value) => (
                    <>
                      <p>
                        TotalAmount ({cart.length} items):
                        <strong> {value}</strong>
                      </p>
                    </>
                  )}
                  decimalScale={2}
                  value={getCartTotal(cart)}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={" ₹ "}
                />
              </div>

              <button className="payment_btn" type="submit">Buy Now</button>
            </form>

          </div>
        </div>

      </div>
    </div>
  )
}

export default Payment